import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RecipeIngredientSection } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { TranslateSafePipe } from '../../../../@shared/translate-safe/translate-safe.pipe';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-recipe-ingredients',
    templateUrl: './recipe-ingredients.component.html',
    styleUrls: ['./recipe-ingredients.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, NgIf, TranslateSafePipe]
})
export class RecipeIngredientsComponent {
    @Input()
    ingredientSections: RecipeIngredientSection[];
}
